import {useSiteLanguage} from "../career/SiteLanguage";
import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Login from "./Login";
import {ChevronDown} from 'lucide-react';
import {useCareerLanguage} from "../career/CareerLanguage";
import CareerLanguageMenu from "../career/CareerLanguageMenu";
import {requestMailNavigation} from "../career/mailNavigation";
import "../styles/Navbar.css";

export default function YeniNavbar() {
  const {tx} = useSiteLanguage();
  const {t}=useCareerLanguage();
  const navigate = useNavigate();
  const userDropdownRef = useRef(null);
  const navbarRef=useRef(null);

  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [user, setUser] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const [languageMenuOpen,setLanguageMenuOpen]=useState(false);

  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");
  const isPersonel = userRole === "personel";

  const onlineMenuText = isPersonel ? "Personel Panelim" : "Fulla Moda Online";
  const onlineMenuPath = isPersonel ? "/profil" : "https://www.fullamoda.com/";

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  useEffect(()=>{
    const outside=e=>{if(!navbarRef.current?.contains(e.target)){setDropdownVisible(false);setMobileMenuOpen(false);}};
    const escape=e=>{if(e.key==='Escape'){setDropdownVisible(false);setMobileMenuOpen(false);}};
    document.addEventListener('pointerdown',outside);document.addEventListener('keydown',escape);
    return()=>{document.removeEventListener('pointerdown',outside);document.removeEventListener('keydown',escape);};
  },[]);
  const openAccount=path=>{setDropdownVisible(false);closeMobileMenu();navigate(path);};

  useEffect(() => {
    let touchStartY = 0;

    const hideNavbar = () => setIsNavbarVisible(false);
    const showNavbar = () => setIsNavbarVisible(true);

    const handleWheel = (e) => {
      if (e.deltaY > 8) hideNavbar();
      if (e.deltaY < -8) showNavbar();
      if (window.scrollY < 10) showNavbar();
    };

    const handleTouchStart = (e) => {
      touchStartY = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
      const currentY = e.touches[0].clientY;
      const diff = touchStartY - currentY;

      if (diff > 12) hideNavbar();
      if (diff < -12) showNavbar();
      if (window.scrollY < 10) showNavbar();
    };

    window.addEventListener("wheel", handleWheel, { passive: true });
    window.addEventListener("touchstart", handleTouchStart, { passive: true });
    window.addEventListener("touchmove", handleTouchMove, { passive: true });

    return () => {
      window.removeEventListener("wheel", handleWheel);
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  useEffect(() => {
    if (!token) return;

    fetchNavbarPhoto();

    const handleProfilePhotoUpdated = () => {
      fetchNavbarPhoto();
    };

    window.addEventListener("profilePhotoUpdated", handleProfilePhotoUpdated);

    return () => {
      window.removeEventListener("profilePhotoUpdated", handleProfilePhotoUpdated);
    };
  }, [token]);

  useEffect(() => {
    let lastY = 0;

    const getCurrentScroll = () => {
      const possibleContainers = [
        document.querySelector(".personel-content"),
        document.querySelector(".personel-container"),
        document.querySelector(".profil-content"),
        document.querySelector(".profil-page"),
      ].filter(Boolean);

      const scrolledContainer = possibleContainers.find(
        (el) => el.scrollTop > 0
      );

      if (scrolledContainer) {
        return scrolledContainer.scrollTop;
      }

      return window.scrollY || document.documentElement.scrollTop || 0;
    };

    const handleScroll = () => {
      const currentY = getCurrentScroll();

      if (currentY > lastY + 8 && currentY > 80) {
        setIsNavbarVisible(false);
      } else if (currentY < lastY - 8) {
        setIsNavbarVisible(true);
      }

      if (currentY < 10) {
        setIsNavbarVisible(true);
      }

      lastY = currentY;
    };

    window.addEventListener("scroll", handleScroll, true);
    document.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
      document.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  const fetchNavbarPhoto = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppbak`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );

      const imgUrl = URL.createObjectURL(res.data);

      setProfilePhoto((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return imgUrl;
      });
    } catch (err) {
      console.error("❌ Navbar profil fotoğrafı alınamadı:", err);
    }
  };

  useEffect(() => {
    const currentUser = localStorage.getItem("user");
    const token = localStorage.getItem("token");

    if (!token) {
      localStorage.removeItem("user");
      localStorage.removeItem("userName");
      localStorage.removeItem("userEmail");
      setUser(null);
      return;
    }

    const checkToken = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/Auth/GetUserIdByToken`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.status === 200) {
          if (currentUser) setUser(JSON.parse(currentUser));
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          localStorage.removeItem("userName");
          localStorage.removeItem("userEmail");
          setUser(null);
        }
      } catch (err) {
        console.error("Token kontrol hatası:", err);
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("userName");
        localStorage.removeItem("userEmail");
        setUser(null);
      }
    };

    checkToken();
  }, []);

  const handleLogout = () => requestMailNavigation(() => {setShowLogoutConfirm(false);performLogout();});
  const performLogout = async () => {
    try {
      const token = localStorage.getItem("token");
      const savedEmail = localStorage.getItem("loginEmail");
      const savedLanguage = localStorage.getItem("career.language");

      await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/logout`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      localStorage.clear();

      if (savedLanguage) localStorage.setItem("career.language",savedLanguage);
      if (savedEmail) {
        localStorage.setItem("loginEmail", savedEmail);
      }

      setUser(null);
      setShowLogoutConfirm(false);
      navigate("/");
      window.location.reload();
    } catch (err) {
      console.error("Çıkış hatası:", err);
    }
  };

  return (
    <>
      <nav ref={navbarRef} className={`navbar ${isNavbarVisible||languageMenuOpen ? "visible" : "hidden"}`}>
        <div className="logo-container" onClick={() => navigate("/")}>
          <img
            src="/images/fulla.png"
            className="logo-img"
            alt="Logo"
            style={{ cursor: "pointer" }}
          />
        </div>

        <ul className="nav-links">
          <li>
            <Link to="/about">{t('about')}</Link>
          </li>

          <li>
            {isPersonel ? (
              <Link to={onlineMenuPath}>{onlineMenuText}</Link>
            ) : (
              <a
                href={onlineMenuPath}
                target="_blank"
                rel="noopener noreferrer"
              >
                {onlineMenuText}
              </a>
            )}
          </li>

          <li>
            <Link to="/joblist">{t('jobs')}</Link>
          </li>

        </ul>

        <div className="nav-buttons">
          <CareerLanguageMenu onOpenChange={setLanguageMenuOpen}/>
          {user ? (
            <div
              className="user-dropdown"
              ref={userDropdownRef}
            >
              <button type="button" className="navbar-user-info" aria-label={tx('Profil')} aria-expanded={dropdownVisible||mobileMenuOpen} onClick={()=>{if(window.innerWidth<=768)toggleMobileMenu();else setDropdownVisible(x=>!x);}}>
                {profilePhoto ? (
                  <img
                    src={profilePhoto}
                    alt={tx("Profil")}
                    className="navbar-user-photo"
                  />
                ) : (
                  <div className="navbar-user-photo-placeholder">👤</div>
                )}

                <span className="user-name">{user?.adi || "Kullanıcı"}</span>
                <ChevronDown size={14} aria-hidden="true"/>
              </button>

              {dropdownVisible && (
                <div className="modern-user-dropdown">
                  {!isPersonel && (
                    <>
                      <button onClick={() => openAccount("/profil")}>{tx("Profil")}</button>

                      <button onClick={() => openAccount("/ozgecmisim")}>{tx("Özgeçmişim")}</button>
                      <button onClick={() => openAccount("/basvurularim")}>{tx("Başvurularım")}</button>
                      <button onClick={() => openAccount("/evraklarim")}>{tx("Evraklarım")}</button>
                    </>
                  )}

                  <button
                    onClick={() => {
                      setShowLogoutConfirm(true);
                      setDropdownVisible(false);
                    }}
                  >{tx("Çıkış Yap")}</button>
                </div>
              )}
            </div>
          ) : (
            <button
              className="login-btn"
              onClick={() => setShowLoginPopup(true)}
            >
              {t('login')}
            </button>
          )}

          <button type="button" className="hamburger-menu" aria-label={tx('Menü')} aria-expanded={mobileMenuOpen} aria-controls="career-mobile-menu" onClick={toggleMobileMenu}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
        </div>

        {mobileMenuOpen && (
          <ul id="career-mobile-menu" className="mobile-nav-links">
            <li>
              <Link to="/about" onClick={closeMobileMenu}>{tx("Hakkımızda")}</Link>
            </li>

            <li>
              {isPersonel ? (
                <Link to={onlineMenuPath} onClick={closeMobileMenu}>
                  {onlineMenuText}
                </Link>
              ) : (
                <a
                  href={onlineMenuPath}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={closeMobileMenu}
                >
                  {onlineMenuText}
                </a>
              )}
            </li>

            <li>
              <Link to="/joblist" onClick={closeMobileMenu}>{tx("İş İlanları")}</Link>
            </li>

            {user && (
              <>
                {!isPersonel && (
                  <>
                    <li>
                      <Link to="/profil" onClick={closeMobileMenu}>{tx("Profil")}</Link>
                    </li>

                    <li>
                      <Link to="/ozgecmisim" onClick={closeMobileMenu}>{tx("Özgeçmişim")}</Link>
                    </li>
                    <li><Link to="/basvurularim" onClick={closeMobileMenu}>{tx('Başvurularım')}</Link></li>
                    <li><Link to="/evraklarim" onClick={closeMobileMenu}>{tx('Evraklarım')}</Link></li>
                  </>
                )}

                <li>
                  <button
                    onClick={() => {
                      closeMobileMenu();
                      setTimeout(() => {
                        setShowLogoutConfirm(true);
                      }, 0);
                    }}
                  >{tx("Çıkış Yap")}</button>
                </li>
              </>
            )}
          </ul>
        )}
      </nav>

      {showLoginPopup && (
        <Login onClose={() => setShowLoginPopup(false)} />
      )}

      {showLogoutConfirm && (
        <div
          className="navbar-logout-overlay"
          onClick={() => setShowLogoutConfirm(false)}
        >
          <div
            className="navbar-logout-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h2>{tx("Çıkış yapmak istiyor musunuz?")}</h2>

            <div className="navbar-logout-actions">
              <button onClick={handleLogout} className="navbar-logout-confirm">{tx("Evet, Çıkış Yap")}</button>

              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="navbar-logout-cancel"
              >{tx("Vazgeç")}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
